// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__7EuBG","message":"Toast_message__XATAT","action":"Toast_action__5tYEs"};